import { render, staticRenderFns } from "./RxdBlockHeadingRow.vue?vue&type=template&id=f693a716&scoped=true&"
import script from "./RxdBlockHeadingRow.vue?vue&type=script&lang=ts&"
export * from "./RxdBlockHeadingRow.vue?vue&type=script&lang=ts&"
import style0 from "./RxdBlockHeadingRow.vue?vue&type=style&index=0&id=f693a716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f693a716",
  null
  
)

export default component.exports